import {
  buttonNavigationColorInput,
  carouselLayoutInputs,
  ctaInputs,
  navigationArrowInputs,
  tileAppearanceInputs,
} from "~/hec/builder/carousel-options/carousel-options.inputs";
import { MAX_RECS_RESULTS } from "~/hec/builder/carousel-options/carousel-options.logic";
import { HEADING_STYLES } from "~/hec/builder/carousel-options/carousel-options.schemas";

const HEADING_STYLE_LABELS = {
  bar: "Gray bar",
  headline: "Headline",
};

// Options shared by both recs blocks, so their Options tabs match.
export const recsOptionInputs = [
  {
    name: "numResults",
    type: "number",
    defaultValue: 10,
    min: 1,
    max: MAX_RECS_RESULTS,
    helperText: `Number of recommendations to fetch (at most ${MAX_RECS_RESULTS}).`,
  },
  // Recs have always shown their heading.
  {
    name: "enableHeadline",
    type: "boolean",
    defaultValue: true,
    friendlyName: "Show heading",
  },
  {
    name: "heading",
    type: "string",
    helperText:
      "Override the heading text. Defaults to the name CIO gives the pod or category.",
  },
  {
    name: "headingStyle",
    type: "string",
    friendlyName: "Heading style",
    showIf: "options.get('enableHeadline') !== false",
    enum: HEADING_STYLES.map(value => ({
      label: HEADING_STYLE_LABELS[value],
      value,
    })),
    defaultValue: HEADING_STYLES[0],
  },
  // Recs have always shown ratings and no tile border.
  ...tileAppearanceInputs.map(input =>
    input.name === "enableBasicView"
      ? { ...input, defaultValue: false }
      : { ...input, helperText: "Leave unset for no border" },
  ),
  // Recs-only tile switches; each starts at what recs tiles have always shown.
  {
    name: "enableAddToCart",
    type: "boolean",
    defaultValue: true,
    friendlyName: "Show add to cart",
    helperText: "Add-to-cart button and quantity stepper on each tile",
  },
  {
    name: "enableQuickView",
    type: "boolean",
    defaultValue: true,
    friendlyName: "Show Quick View",
    helperText:
      "Off hides the Quick View button only: QA requires it on every recs tile (SFCC-11590), and adding a product with options still opens Quick View to pick one",
  },
  {
    name: "enableFavorites",
    type: "boolean",
    defaultValue: false,
    friendlyName: "Show favorites heart",
  },
  {
    name: "enableLowStockBadge",
    type: "boolean",
    defaultValue: true,
    friendlyName: "Show low-stock badge",
    helperText: '"Only N left!" when stock is low',
  },
  ...carouselLayoutInputs,
  // Recs have always shown arrows: the on/off switches start on, and the
  // per-breakpoint ones stay visible unless arrows are switched off.
  ...navigationArrowInputs.map(input => ({
    ...input,
    ...(input.type === "boolean" ? { defaultValue: true } : {}),
    ...("showIf" in input
      ? { showIf: `options.get('enableNavigationArrows') !== false` }
      : {}),
  })),
  // Recs have no pagination dots, so the color goes on the arrows.
  {
    ...buttonNavigationColorInput,
    helperText: "Arrow border and icon color; leave unset for dark blue",
  },
  ...ctaInputs,
];
